import React ,{useState,useEffect,useContext}from "react";
import { MultiSelectView } from "./PartnerPreferenceUtils";

import { LoginContext } from "../../../Contexts/LoginContext";
import EndPoints from "../../../Constants/EndPoints";
import { IP_Address } from "../../../Constants/IpAddress";
import { POST, GET } from "../../../Services/api_services";
import config from "../../../config";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const AstrologicalPreference = (props) => {
    const [raasiDropDown, setRaasiDropDown] = useState([]);
  const userData = useSelector(
    (state) => state?.DashBoardAPI?.ProfileData?.data,
  );
    const { loginDetail, logout } = useContext(LoginContext);

    const { t: trans } = useTranslation();

    const OnChangeBottomData =()=>{
      if(props?.isFrom=="basicPE"){
        props?.ShowBottomTab(true)
        props?.showPEBottomTab?.(true)
      }else{
        props?.ShowBottomTab?.(false)
      }
    }

    useEffect(()=>{

    },[raasiDropDown])
    useEffect(()=>{
        setRaasiDropDown(props?.edithoroinfofreshData?.raasi)
    },[props?.edithoroinfofreshData])
    const motherTongue = useSelector(
      (state) => state?.DashBoardAPI?.ProfileData?.data?.mothertongueid,
    );

    const apiCallRaasi = async (value) => {
        let { statusCode, data } = await GET(
          `${config.api.API_URL}${EndPoints.getRaasiUrl(value, userData?.mothertongueid)}`
        );
        if (statusCode === 200) {
          if (data.status == "Success") {
            setRaasiDropDown(data.data.raasi);
            let temp = []
            if(data.data.raasi?.length>0){
              data.data.raasi?.map((raasi, i) => {
                temp.push(raasi.id)
              })
            }
            props.data.setFieldValue("raasi", temp);
          }

        } else if (statusCode === 401) {
          logout();
        }
      };
  return (
    <div>
        
      <MultiSelectView
        title={trans('my_profile.star')}
        inputID={"star"}
        inputName={"star"}
        value={props.data.values.star}
        defalutValue={[props.data.values.star]}
        onChange={(e) => {
          props?.handleSelectInputChange?.(e);
          props?.apicallsearchpagenewcount?.(props.data.values);  
          
          OnChangeBottomData()
          
          props.data.setFieldValue("star", Array.from(e));
          apiCallRaasi(Array.from(e))
          if(props.isTrailPack == 'Y'){
            props.setOnchangeData(false)
          }
        }}
        error={props.data.errors.star}
        options={props?.edithoroinfofreshData?.star}
        isDisabled={props.editfromadmin == 'Y'}
      />
      <MultiSelectView
        title={trans('my_profile.raasi')}
        inputID={"raasi"}
        inputName={"raasi"}
        value={props.data.values.raasi}
        defalutValue={[props.data.values.raasi]}
        onChange={(e) => {
          props?.handleSelectInputChange?.(e);
          props?.apicallsearchpagenewcount?.(props.data.values);  
          
          OnChangeBottomData()
          props.data.setFieldValue("raasi", Array.from(e));
          // props.data.handleChange
          if(props.isTrailPack == 'Y'){
            props.setOnchangeData(false)
          }
        }}
        error={props.data.errors.raasi}
        options={raasiDropDown}
        isDisabled={props.editfromadmin == 'Y'}
      />
      <MultiSelectView
        title={trans('my_profile.dosham')}
        placeholder={trans('common_placeholder.any')}
        inputID={"dosam"}
        inputName={"dosam"}
        value={props.data.values.dosam}
        defalutValue={[props.data.values.dosam]}
        onChange={(e) => {
          props?.handleSelectInputChange?.(e);
          props?.apicallsearchpagenewcount?.(props.data.values);  
          
          OnChangeBottomData()
          props.data.setFieldValue("dosam", Array.from(e));
          // props.data.handleChange
          if(props.isTrailPack == 'Y'){
            props.setOnchangeData(false)
          }
        }}
        error={props.data.errors.dosam}
        options={props?.edithoroinfofreshData?.dosham}
        isDisabled={props.editfromadmin == 'Y'}
      />
    </div>
  );
};

export default AstrologicalPreference;
